<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="所属分类" prop="problemTypeId">-->
<!--        <a-select placeholder="请选择" allowClear v-model="form.problemTypeId">-->
<!--          <a-select-option v-for="(d, index) in problemTypeOptions" :key="index" :value="d.id" >{{ d.title }}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('problem.title')" prop="titleIn" >
        <a-input v-model="form.titleIn" :placeholder="$t('problem.inputTitle')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('problem.titleEn')" prop="titleEn" >
        <a-input v-model="form.titleEn" :placeholder="$t('problem.inputTitleEn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('problem.titleCn')" prop="titleCn" >
        <a-input v-model="form.titleCn" :placeholder="$t('problem.inputTitleCn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('problem.titleArabic')" prop="title" >
        <a-input v-model="form.title" :placeholder="$t('problem.inputTitleArabic')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('problem.content')" prop="contentInfoIn" >
        <editor editorValue="contentInfoIn" v-model="form.contentInfoIn" />
      </a-form-model-item>
      <a-form-model-item :label="$t('problem.contentEn')" prop="contentInfoEn" >
        <editor editorValue="contentInfoEn" v-model="form.contentInfoEn" />
      </a-form-model-item>
      <a-form-model-item :label="$t('problem.contentCn')" prop="contentInfoCn" >
        <editor editorValue="contentInfoCn" v-model="form.contentInfoCn" />
      </a-form-model-item>
      <a-form-model-item :label="$t('problem.contentArabic')" prop="contentInfo" >
        <editor editorValue="contentInfo" v-model="form.contentInfo" />
      </a-form-model-item>
      <a-form-model-item :label="$t('problem.sort')" prop="orderSort" >
        <a-input v-model="form.orderSort" :placeholder="$t('problem.inputSort')" type="number" allow-clear />
      </a-form-model-item>
<!--      <a-form-model-item label="状态" prop="status">-->
<!--        &lt;!&ndash; 1正常 0停用 &ndash;&gt;-->
<!--        <a-radio-group v-model="form.status" button-style="solid">-->
<!--          <a-radio-button v-for="(d, index) in statusOptions" :key="index" :value="d.value">-->
<!--            {{ d.label }}-->
<!--          </a-radio-button>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getProblem, addProblem, updateProblem } from '@/api/problem/problem'
import Editor from "@/components/Editor";

export default {
  name: 'CreateForm',
  props: {
    problemTypeOptions: {
      type: Array,
      required: true
    }
  },
  components: {
    Editor
  },
  data () {
    return {
      replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id' },
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        problemTypeId: null,
        title: null,
        titleEn: null,
        titleCn: null,
        titleIn: null,
        contentInfo: null,
        contentInfoEn: null,
        contentInfoCn: null,
        contentInfoIn: null,
        orderSort: null,
        status: 0
      },
      statusOptions: [
        {
          label: '正常',
          value: 1
        },
        {
          label: '停用',
          value: 0
        }
      ],
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        problemTypeId: [
          { required: true, message: this.$t('problem.problemTypeIdRequired')}
        ],
        titleIn: [
          { required: true, message: this.$t('problem.titleRequired') }
        ],
        orderSort: [
          { required: true, message: this.$t('problem.sortRequired') }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1

      this.$nextTick(() => {this.form = {
        id: null,
        problemTypeId: undefined,
        title: null,
        titleEn: null,
        titleCn: null,
        titleIn: null,
        contentInfo: null,
        contentInfoEn: null,
        contentInfoCn: null,
        contentInfoIn: null,
        orderSort: null,
        status: 0
      }

        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getProblem({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateProblem(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addProblem(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
